import { create } from "zustand";
import { persist } from "zustand/middleware";

interface OtpState {
  phone: string | null;
  expiresAt: number | null;
  code: string | null;
  resetToken: string | null;

  setOtp: (phone: string, expiresInSeconds: number) => void;
  setCode: (code: string | null, resetToken?: string | null) => void;
  clearOtp: () => void;
  isOtpValid: () => boolean;
}

export const useAuthStore = create<OtpState>()(
  persist(
    (set, get) => ({
      phone: null,
      expiresAt: null,
      code: null,
      resetToken: null,

      setOtp: (phone, expiresInSeconds) => {
        const expiresAt = Date.now() + expiresInSeconds * 1000;

        set({
          phone,
          expiresAt,
          code: null, // reset code when new OTP is issued
          resetToken: null,
        });
      },

      setCode: (code, resetToken = null) => {
        set({ code, resetToken });
      },

      clearOtp: () =>
        set({
          phone: null,
          expiresAt: null,
          code: null,
          resetToken: null,
        }),

      isOtpValid: () => {
        const { expiresAt } = get();
        if (!expiresAt) return false;
        return Date.now() < expiresAt;
      },
    }),
    {
      name: "otp-auth",
      partialize: (state) => ({
        phone: state.phone,
        expiresAt: state.expiresAt,
        code: state.code,
        resetToken: state.resetToken,
      }),
    }
  )
);
